import * as types from 'store/modules/hres6de/mutation-types'
import hres6de from 'api/hres6de'
import swal from 'sweetalert'

export default {
  state: {
    hres6deIndex: {
      total: 0,
      rows: [{
        checkbox: false,
        dtereq: new Date(),
        seqno: 1,
        dtework: new Date(),
        descStareq: '',
        remarkap: '',
        descCodappr: '',
        descCodempap: ''
      }]
    }
  },
  getters: {
    [types.GET_HRES6DE_INDEX] (state) {
      return state.hres6deIndex
    }
  },
  mutations: {
    [types.SET_HRES6DE_INDEX] (state, hres6deIndex) {
      state.hres6deIndex = hres6deIndex
    }
  },
  actions: {
    [types.RECEIVED_HRES6DE_INDEX] ({ commit }, params) {
      hres6de.getIndexTable(params)
        .then((response) => {
          const hres6deIndex = JSON.parse(response.request.response)
          commit(types.SET_HRES6DE_INDEX, hres6deIndex)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres6de/index.js